import React from 'react';

const PinIcon = () => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M8,0A6.38,6.38,0,0,0,1.6,6.4c0,4.32,5.64,9.2,5.88,9.41a.81.81,0,0,0,1,0c.28-.21,5.88-5.09,5.88-9.41A6.38,6.38,0,0,0,8,0ZM8,14.12c-1.7-1.6-4.8-5-4.8-7.72a4.8,4.8,0,0,1,9.6,0C12.8,9.07,9.7,12.53,8,14.12Z" />
    <path d="M8,3.2a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,8,3.2ZM8,8A1.6,1.6,0,1,1,9.6,6.4,1.6,1.6,0,0,1,8,8Z" />
  </svg>
);

export default PinIcon;
